// Sonuç tablosunda toptan göçme satırı: Web Worker deposundan okur; analiz kapalıysa (idle) satır yok.
// Diğer kontrollerle aynı dil: oran çubuğu (hedef/GK), sayı, ✓/✗ ve hüküm satırı; sütunlar tablonun yük durumu sütunlarıdır.
import { t } from "../../i18n";
import { tEngine } from "../../i18n/engine";
import { fmt, type CaseId, type GlobalStabilityResult } from "@tasduvar/engine";
import { useGlobalStabilityStore } from "../../state/useGlobalStability";
import { RatioBar } from "./RatioBar";

function Cell({ c, label, cad }: { c: GlobalStabilityResult | undefined; label: string; cad?: boolean }): JSX.Element {
  if (!c) return <td className="text-xs text-stone align-top py-1">{t("Yalnız statik")}</td>;
  const ratio = Number.isFinite(c.fsMin) ? c.target / c.fsMin : 0;
  if (cad) return (
    <td className="align-top px-1 py-0.5">
      <div className="flex items-center gap-1.5"><RatioBar cad ratio={ratio} ok={c.ok} label={`${label} GK`} /><span className="font-mono tabular-nums text-[11px] flex-1 text-right">GK {fmt(c.fsMin, 2)}</span><span aria-hidden className={c.ok ? "text-[#1D7A46]" : "text-[#B42318]"}>{c.ok ? "✓" : "✗"}</span></div>
      <div className={`text-[10px] truncate ${c.ok ? "text-cad-ink3" : "text-[#B42318]"}`} title={tEngine(c.verdict)}>{tEngine(c.verdict)}</div>
    </td>
  );
  return (
    <td className="align-top py-1">
      <div className="flex items-center gap-2"><RatioBar ratio={ratio} ok={c.ok} label={`${label} GK`} /><span className="num text-xs whitespace-nowrap">GK {fmt(c.fsMin, 2)}</span><span aria-hidden>{c.ok ? "✓" : "✗"}</span></div>
      <div className={`text-[11px] ${c.ok ? "text-ink/75" : "text-bad"}`}>{tEngine(c.verdict)}</div>
    </td>
  );
}

export function GlobalStabilityRow({ cols, cad }: { cols: { id: CaseId; label: string }[]; cad?: boolean }): JSX.Element | null {
  const gs = useGlobalStabilityStore();
  if (gs.status === "idle") return null;
  const label = t("Toptan göçme");
  let body: JSX.Element;
  if (gs.status === "running") body = <td colSpan={cols.length} className="text-xs text-stone align-top py-1.5">{t("Hesaplanıyor…")}</td>;
  else if (gs.status === "error") body = <td colSpan={cols.length} className="text-xs text-bad align-top py-1.5">{gs.error}</td>;
  else if (gs.result) body = <>{cols.map((c) => <Cell key={c.id} c={c.id === "static" ? gs.result!.static : gs.result!.seismic} label={`${label} ${c.label}`} cad={cad} />)}</>;
  else return null;
  return (
    <tr aria-label={label} className={cad ? "border-b border-cad-soft2" : "border-t border-rule"} role="status" data-status={gs.status}>
      <td className={cad ? "align-top px-1 py-0.5" : "align-top py-1.5 font-medium"}>{label}</td>
      {body}
    </tr>
  );
}
